import React from 'react';

const NoMessageIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 200" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M179.008 137.285C175.401 139.864 171.884 142.288 167.902 144.383L168.133 163.248C168.151 164.727 166.912 165.941 165.366 165.958C164.737 165.965 164.124 165.769 163.625 165.402L145.897 152.352C139.252 153.815 132.243 154.598 125 154.598C82.4735 154.598 47.999 127.611 47.999 94.3197C47.999 61.0287 82.4735 34.041 125 34.041C167.526 34.041 202.001 61.0287 202.001 94.3197C202.001 103.534 199.36 112.265 194.638 120.075C193.767 121.516 192.826 122.925 191.817 124.3C191.817 124.3 189.845 127.138 185.901 131.157C181.957 135.175 179.008 137.285 179.008 137.285Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M179.008 137.285C175.401 139.864 171.884 142.288 167.902 144.383L168.133 163.248C168.151 164.727 166.912 165.941 165.366 165.958C164.737 165.965 164.124 165.769 163.625 165.402L145.897 152.352C139.252 153.815 132.243 154.598 125 154.598C82.4735 154.598 47.999 127.611 47.999 94.3197C47.999 61.0287 82.4735 34.041 125 34.041C167.526 34.041 202.001 61.0287 202.001 94.3197C202.001 103.534 199.36 112.265 194.638 120.075C193.767 121.516 192.826 122.925 191.817 124.3C191.817 124.3 189.845 127.138 185.901 131.157C181.957 135.175 179.008 137.285 179.008 137.285Z"
        stroke="#6485A7"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M170.995 77.6961C178.421 77.6961 185.573 76.8488 192.273 75.2813C194.946 81.1078 196.401 87.3859 196.401 93.9283C196.401 102.415 193.952 110.457 189.574 117.651C188.766 118.978 187.893 120.275 186.958 121.542C185.481 123.542 184.428 124.953 183.5 126.086C181.307 128.764 179.817 129.877 175.08 133.502C171.921 135.92 168.474 138.11 164.782 140.04L164.996 157.416C165.013 158.779 165.446 161.28 164.012 161.297C163.429 161.303 161.278 159.738 160.816 159.4L146.522 147.187C140.36 148.535 131.716 149.449 125 149.449C85.5664 149.449 53.5991 124.592 53.5991 93.9283C53.5991 68.8171 75.038 47.5996 104.459 40.7393C112.165 62.0036 139.033 77.6961 170.995 77.6961ZM97.407 86.4817C92.78 86.4817 89.029 90.0938 89.029 94.5495C89.029 99.0052 92.78 102.617 97.407 102.617C102.034 102.617 105.785 99.0052 105.785 94.5495C105.785 90.0938 102.034 86.4817 97.407 86.4817ZM123.938 86.4817C119.311 86.4817 115.56 90.0938 115.56 94.5495C115.56 99.0052 119.311 102.617 123.938 102.617C128.565 102.617 132.316 99.0052 132.316 94.5495C132.316 90.0938 128.565 86.4817 123.938 86.4817ZM150.468 86.4817C145.841 86.4817 142.09 90.0938 142.09 94.5495C142.09 99.0052 145.841 102.617 150.468 102.617C155.095 102.617 158.846 99.0052 158.846 94.5495C158.846 90.0938 155.095 86.4817 150.468 86.4817Z"
        fill="#F1F5F9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.9997 86.2832C101.639 86.2832 105.4 89.8816 105.4 94.3204C105.4 98.7592 101.639 102.358 96.9997 102.358C92.3605 102.358 88.5996 98.7592 88.5996 94.3204C88.5996 89.8816 92.3605 86.2832 96.9997 86.2832ZM123.6 86.2832C128.239 86.2832 132 89.8816 132 94.3204C132 98.7592 128.239 102.358 123.6 102.358C118.961 102.358 115.2 98.7592 115.2 94.3204C115.2 89.8816 118.961 86.2832 123.6 86.2832ZM150.2 86.2832C154.84 86.2832 158.6 89.8816 158.6 94.3204C158.6 98.7592 154.84 102.358 150.2 102.358C145.561 102.358 141.8 98.7592 141.8 94.3204C141.8 89.8816 145.561 86.2832 150.2 86.2832Z"
        fill="white"
        stroke="#6485A7"
        strokeWidth="2.5"
      />
      <path
        d="M68.5264 74.6436C67.2552 76.6956 66.1535 78.8252 65.2358 81.021"
        stroke="#6485A7"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M94.2305 52.8926C85.0565 57.0817 77.3114 63.0075 71.7144 70.1015"
        stroke="#6485A7"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default NoMessageIcon;
